import fetch from '@/utils/fetch';
import * as types from './mutation_types';

export const loadSeenIds = ({commit, dispatch}) => {
    return fetch('news-seen', {dispatch})
        .then((response) => response.json())
        .then((data) => {
            commit(types.CHANGELOG_SET_SEEN_IDS, data.seenIds || []);
        })
        .catch((e) => {
            console.error('changelog/loadSeenIds selhalo', e);
        });
};

// Optimisticky lokalni zapis hned (at se stejna polozka neukaze znovu pri
// rychlem prekliku mezi slidy pred dorazenim odpovedi), POST na server je
// fire-and-forget - stejny princip jako syncFlagsFromBackend() v App.vue.
export const markSeen = ({commit, dispatch, state}, ids) => {
    const newIds = ids.filter((id) => !state.seenIds.includes(id));
    if (newIds.length === 0) {
        return Promise.resolve();
    }

    commit(types.CHANGELOG_ADD_SEEN_IDS, newIds);

    return fetch('news-seen', {
        method: 'POST',
        body: JSON.stringify({ids: newIds}),
        dispatch,
    }).catch((e) => {
        console.error('changelog/markSeen selhalo', e);
    });
};
